import styled from '@emotion/styled';
import { GenericLazyString } from '@eventbrite/i18n';
import { Typography } from '@eventbrite/marmalade';
import React from 'react';

export const Illustration = ({
    title,
    body,
    svg,
}: {
    title: GenericLazyString;
    body: GenericLazyString;
    svg: React.ReactNode;
}) => {
    return (
        <Container>
            <Headers>
                <Typography as="h1" color="neutral-900" variant="heading-sm">
                    {title}
                </Typography>
                <Typography as="p" variant="body-md">
                    {body}
                </Typography>
            </Headers>

            <SVGContainer>{svg}</SVGContainer>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 32px;
`;

const Headers = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const SVGContainer = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
`;
